import { render, staticRenderFns } from "./VaccinePricingCampaignEditForm.vue?vue&type=template&id=606506df&"
import script from "./VaccinePricingCampaignEditForm.vue?vue&type=script&lang=js&"
export * from "./VaccinePricingCampaignEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports